import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=0e3cecaa&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=ts&"
export * from "./Access.vue?vue&type=script&lang=ts&"
import style0 from "./Access.vue?vue&type=style&index=0&id=0e3cecaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3cecaa",
  null
  
)

export default component.exports